export default {
	status: {
		400: "Échec de la demande ! Veuillez réessayer plus tard",
		401: "La session de connexion a expiré ! Veuillez vous reconnecter",
		403: "Le compte actuel n'a pas de permission d'accès",
		404: "La ressource à laquelle vous essayez d'accéder n'existe pas",
		405: "Méthode de requête incorrecte ! Veuillez réessayer plus tard",
		408: "La demande a expiré ! Veuillez réessayer plus tard",
		500: "Le service a rencontré une exception",
		990: "Votre compte est bloqué depuis longtemps en raison de tâches non accomplies",
		10030008: "Veuillez restituer le fonds d'assistance avant de demander un retrait d'argent",
		10030010: "Le code d'invitation n'existe pas",
		10030011: "Le nombre maximum d'heures d'enregistrement a été dépassé",
		10030012: "Ne remplit pas les conditions d'enregistrement, veuillez d'abord terminer la tâche",
		10030013: "Erreur de configuration de l'enregistrement, veuillez contacter le service clientèle",
		10030014: "Pas dans la période de temps autorisée",
		10030015: "Le membre n'existe pas",
		10030016:
			"Cher utilisateur : Félicitations ! Vous avez réussi à compléter 100 % de la promotion de votre produit. Veuillez contacter le support de la plateforme pour demander une réinitialisation.",
		10030017: "Impossible de faire correspondre le produit, veuillez contacter le service clientèle",
		10030018: "Solde du compte insuffisant",
		10030019: "Le compte a été désactivé",
		10030020: "Compte interdit de transactions",
		10030021: "Retrait du compte interdit",
		10030022: "Erreur de mot de passe de transaction",
		10030023: "Le compte de retrait n'est pas lié, veuillez d'abord lier le compte de retrait",
		10030024: "Ancienne erreur de mot de passe",
		10030027: "Votre retrait est limité. Veuillez contacter le service clientèle pour plus de détails",
		10030028: "Un faible score de crédit vous empêche de retirer de l'argent",
		10030030: "Pas dans la période autorisée",
		10030031: "Vous devez effectuer une série de tâches d'optimisation avant de pouvoir demander un retrait",
		10030050: "La commande a expiré. Veuillez contacter le service client pour obtenir de l'aide."
	},
	errorHandler: {
		InternalError: "Erreur interne du moteur JavaScript",
		ReferenceError: "Objet non trouvé",
		TypeError: "Type ou objet incorrect utilisé",
		RangeError: "Paramètre hors de portée lors de l'utilisation d'objets intégrés",
		SyntaxError: "Erreur de syntaxe",
		EvalError: "Utilisation incorrecte de Eval",
		URIError: "Erreur d'URI",
		UnknownError: "Inconnu"
	},
	Network: {
		timedout: "Request timed out ! Veuillez réessayer plus tard",
		error: "Erreur de réseau ! Veuillez réessayer plus tard"
	},
	request: {
		NoMoreData: "Plus de données",
		OnlyImage: "Veuillez télécharger uniquement des fichiers image.",
		FileMaxSize: "La taille du fichier dépasse la valeur maximale, qui est de {0}M"
	},
	response: {
		loading: "Chargement",
		success: "Succès",
		fail: "Échec",
		complete: "Complète"
	},
	page: {
		noVerify: "Billetera no verificada, por favor verifique su billetera primero",
		notexist: "Désolé, la page à laquelle vous essayez d'accéder n'existe pas~"
	}
};
